module.exports = __webpack_public_path__ + "img/identify03.4e0ea161.png";